import { render, staticRenderFns } from "./relatedInformation.vue?vue&type=template&id=31746451&scoped=true&"
import script from "./relatedInformation.vue?vue&type=script&lang=js&"
export * from "./relatedInformation.vue?vue&type=script&lang=js&"
import style0 from "./relatedInformation.vue?vue&type=style&index=0&id=31746451&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31746451",
  null
  
)

export default component.exports